import { useSelector } from 'react-redux';

import usePendingChangeAuthors from 'hooks/usePendingChangeAuthors';

import { selectDealFromApplication } from 'store/loanApplications/selectors';

/**
 * Pending-change author rows by field for the loan, its application and any other entities a loan tab's
 * read-only view shows, for the author dots next to its highlighted values.
 * @param {...String} entityKeys
 * @returns {Object}
 */
const useLoanPendingChangeAuthors = (...entityKeys) => {
  const deal = useSelector(selectDealFromApplication);

  return usePendingChangeAuthors(deal?.loanId, deal?.applicationId, ...entityKeys);
};

export default useLoanPendingChangeAuthors;
